import {
  OcrModelType,
  OcrModelMetadata,
  OcrInferenceConfig,
} from "../types/ocrInferenceConfig";

export const OCR_MODEL_METADATA_MAP: Record<OcrModelType, OcrModelMetadata> = {
  "ocr-nightly": {
    apiName: "ocr-nightly",
    displayName: "OCR Nightly",
    requiredRoles: undefined,
    endpointType: "ocr",
  },
  "ocr-250904": {
    apiName: "ocr-250904",
    displayName: "OCR 250904",
    requiredRoles: undefined,
    endpointType: "ocr",
  },
  "ocr-260630": {
    apiName: "ocr-260630",
    displayName: "OCR 260630",
    requiredRoles: undefined,
    endpointType: "ocr",
  },
  "ocr-260930": {
    apiName: "ocr-260930",
    displayName: "OCR 260930",
    requiredRoles: undefined,
    endpointType: "ocr",
  },
};

export const DEFAULT_OCR_INFERENCE_CONFIG: OcrInferenceConfig = {
  model: "ocr-260930",
};
